import { useMyMonitoringGetDefaultMediaImages } from '@apps-common/apis/my-monitoring/site'
import { useGetDefaultMediaImages } from '@apps-common/apis/portal/media/get-default-media-images'
import { ImageComponent } from '@apps-common/components/common'
import { FieldInfoMessage, ImageSelect } from '@apps-common/components/elements/form'
import { VertSpacerLg } from '@apps-common/components/layout'
import { ModalBody, ModalCloseButton, ModalContainer, ModalHeader, ModalHeaderContainer } from '@apps-common/components/modals/modal'
import { commonIcons } from '@apps-common/config/icons'
import { ModalDismiss } from '@apps-common/config/modal'
import { useProjectHook } from '@apps-common/hooks/useProjectHook'

interface IProps {
  siteImage?: string
}

export const SiteImageSelectModal = ({
  onDismiss,
  componentProps
}: {
  onDismiss: (data?: any, role?: string) => void
  componentProps: IProps
}) => {
  const useGetDefaultMediaHook = useProjectHook(useGetDefaultMediaImages, useMyMonitoringGetDefaultMediaImages)

  const { data, isLoading, isError } = useGetDefaultMediaHook({})

  const loading = false
  const updating = false

  return (
    <ModalContainer alwaysMobile innerClasses=''>
      <ModalHeaderContainer classes='!pb-1'>
        <div className='flex items-center justify-between'>
          <ModalHeader subtitle='Select' title='Site Image' />
          <ModalCloseButton closeModal={() => onDismiss(null, ModalDismiss.Cancel)} />
        </div>
        <div className='pt-1'>
          <FieldInfoMessage classes='!text-[0.85rem] !pl-0' message='Select from a range of pre-selected images or upload an image.' />
        </div>
      </ModalHeaderContainer>
      <ModalBody classes='!pt-[110px] sm:!pt-[100px]'>
        <VertSpacerLg />
        <div className='grid grid-cols-3 md:grid-cols-4 gap-4'>
          <ImageSelect
            onChangeCallback={(imageFile: any) => {
              if (!imageFile) return
              onDismiss({ imgUrl: null, file: imageFile }, ModalDismiss.Confirm)
            }}
            onClearCallback={(imageFile: any) => {}}
            cropDimensions={{
              width: 200,
              height: 200
            }}
            containerClasses='w-full h-full'
            clearChildren={<div />}
            disabled={loading || updating}
          >
            <div className='bg-text/10 text-text border border-text/10 w-full h-full flex flex-col items-center justify-center rounded-full'>
              <commonIcons.camera className='text-[2.2rem]' />
              <div className='text-[0.7rem] leading-[0.8rem] uppercase'>
                Upload
                <br />
                image
              </div>
            </div>
          </ImageSelect>
          {data?.map((d: string, i: number) => (
            <button
              type='button'
              key={`site-default-image-select-${i}`}
              className='w-full h-full rounded-full overflow-hidden'
              onClick={() => onDismiss({ imgUrl: d, file: null }, ModalDismiss.Confirm)}
            >
              <div className='relative w-full pt-[100%]'>
                <ImageComponent src={d} alt={`Default image option ${i}`} imageClasses='absolute top-0 left-0 w-full h-[100%]' />
              </div>
            </button>
          ))}
        </div>
        <div className='flex items-center justify-center pt-[50px]'>
          <p className='text-text text-[0.8rem] jost-light opacity-70'>
            Images sourced from <span className='jost-medium'>Unsplash</span>.
          </p>
        </div>
      </ModalBody>
    </ModalContainer>
  )
}
